import { memo } from 'react'
import { useIntl } from 'react-intl'
import ExperienceCategoryChip from './ExperienceCategoryChip'
import ExploreChipCarousel from 'tripPlanner/components/Chat/ExploreChipCarousel'
import type { ExperienceCategoryFilter } from './experienceCategoryFiltering'

interface Props {
  categories: Array<ExperienceCategoryFilter>
  selectedCategoryId: number | undefined
  onSelectCategory: (categoryId: number | undefined) => void
  isFetching?: boolean
}

function ExperienceCategoryFilters({
  categories,
  selectedCategoryId,
  onSelectCategory,
  isFetching,
}: Props) {
  const intl = useIntl()

  return (
    <ExploreChipCarousel
      label={intl.formatMessage({
        id: '4_yqC4DiyfZ3kB9FsU3R',
        defaultMessage: 'Filter experiences by category',
        description: 'Accessible name for the row of category filter chips in the trip planner experiences list',
      })}
    >
      {categories.map((category) => (
        <ExperienceCategoryChip
          key={category.id}
          category={category}
          isSelected={category.id === selectedCategoryId}
          isDisabled={isFetching}
          onSelect={onSelectCategory}
        />
      ))}
    </ExploreChipCarousel>
  )
}

export default memo(ExperienceCategoryFilters)
